<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/blue-code.jpg')" >
      </parallax>
      <div class="content-center">
        <div class="container">
          <img class="n-logo" src="img/stormhaven-logo.small.png" alt="" />
          <h1 class="title">Graphics Programmer</h1>
        </div>
      </div>
    </div>
    <div class="section">
        <div class="container">
            <div class="row">
                <p>A Graphics Programmer is the main gateway between the code, art, and tech teams. The GP should have a combination of strong creative/visual aesthetics and technical knowledge. We are looking for a candidate with extensive experience in every aspect of the content creation pipeline and someone who will apply ingenuity to the Embers Adrift MMORPG. This individual will have a proven track record of successfully working collaboratively, solving pipeline problems, and creating and improving cutting-edge tools and processes on art teams, and game production experience in a lead role.</p>
                <p style="font-weight: bold;">This is a full-time, salaried position.</p>
                <p>While we are an Austin, Texas company, we fully support a remote work force and encourage talented individuals from anywhere in the world to apply. We are an equal opportunity employer.</p>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Your Background</div>
            </div>
            <div class="row">
                <ul>
                    <li>4+ years’ experience in video games as a lead or technical artist</li>
                    <li>Shipped at least 1 AAA or Indie title as a graphics programmer</li>
                    <li>Bachelor’s degree in Computer Science or equivalent experience</li>
                    <li>Experience with HLSL shader language</li>
                    <li>Experience with the C# programming language</li>
                    <li>Expertise in building multithreaded, real-time systems</li>
                    <li>Experience writing systems balancing performance and maintainability</li>
                    <li>Excellent analytical and mathematical skills</li>
                    <li>Experience profiling and optimizing both CPU and GPU utilization</li>
                    <li>Experience with game editor plugins/modification</li>
                    <li>Able to work in a fast-paced environment and comfortable dealing with ambiguity</li>
                    <li>Excellent communication and time management skills</li>
                    <li>Very strong problem-solving skills</li>
                    <li>Act as a role model and mentor technical art team</li>
                    <li>Provide team performance evaluations</li>
                    <li>Ability to contribute innovative and original ideas towards all aspects of game production and development</li>
                    <li>Strong communication and organizational skills</li>
                    <li>Must work well under pressure and handle multiple tasks</li>
                    <li>Passion for making GREAT games</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Day to Day Tasks</div>
            </div>
            <div class="row">
                <ul>
                    <li>Understands Unity graphics engine architecture, from game interface to graphics API interface</li>
                    <li>Writes and maintains custom shaders across a range of hardware intended for Unity 2018’s Scriptable Rendering Pipeline (SRP)</li>
                    <li>Writes clear, maintainable and highly functional code</li>
                    <li>Test and document code you write</li>
                    <li>Supports and maintains existing systems</li>
                    <li>Accurately estimates his/her schedules and delivers high quality work products to that schedule</li>
                    <li>Coordinate the technical art department, prioritize features, and work with all required team members to achieve common goals across the departments</li>
                    <li>Constantly review the content creation pipeline to identify and fix any possible pipeline or technology deficiencies for the art department</li>
                    <li>Take requests, prioritize, and delegate work across the technical department while maintaining a consistent task list and priorities for the technical art team</li>
                    <li>Create best-practices documentation for art team on creating great-looking optimized game assets (models, textures, shaders, lighting, FX, etc.)</li>
                    <li>Use diagnostic tools to examine current content, game performance, and identify areas for improvement</li>
                    <li>Work with art team/engineers to develop/optimize shaders, improve rendering, lighting, and post processing to enhance visual quality and better performance</li>
                    <li>R&amp;D complex game art elements</li>
                    <li>Assist art team members with production tools and upgrades.</li>
                    <li>Collaborate with art and engineering staff on art pipeline improvements</li>
                    <li>Assist in trouble-shooting and organization with outsourced art partners as needed</li>
                    <li>Remain up-to-date on tool and tech developments to identify ways to improve quality and increase art production speed</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Pluses</div>
            </div>
            <div class="row">
                <ul>
                    <li>Bachelor’s degree in Art, Animation, Game Development or Computer Science</li>
                    <li>Experience developing MMORPGs or multiplayer games</li>
                    <li>Substance Painter</li>
                    <li>Substance DesignerPBR material authoring in one or more authoring software</li>
                    <li>Quixel</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Requirements for Applying</div>
            </div>
            <div class="row">
                <ul>
                    <li>Resume</li>
                    <li>Cover letter which should include:
                        <ul>
                            <li>Why you are interested in working at Stormhaven Studios, LLC</li>
                            <li>What games you are currently playing</li>
                        </ul>
                    </li>
                    <li>Portfolio – Only digital applications will be accepted such as a website, blog, or online album.  Physical media will not be accepted.</li>
                    <li>A paid test may be requested during the interview process</li>
                </ul>
            </div>
            <div class="row">
                <p>Stormhaven Studios, LLC is a global company committed to growing our contractors and employees along with the business. We’ve worked hard to foster an intensely collaborative and creative environment with a diverse and inclusive culture of people from around the world, with training and opportunity for professional growth. Our people are everything to us. We are dedicated to creating the most epic entertainment experiences…ever. We look forward to having you on the team!</p>
            </div>
            <div class="row" style="margin-top: 24px;">
                <h2><a href="mailto:jobs@stormhavenstudios.com">Apply Now!</a></h2>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'graphicprogrammer',
  bodyClass: 'landing-page'
};
</script>
<style></style>
